import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/_services/login.service';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, AbstractControl } from '@angular/forms';
import { GlobalService } from '../_services/global.service';
import { GoogleLoginService } from '../_services/google-login.service';
import { environment } from 'src/environments/environment';
import { TransactionService } from '../_services/transaction.service';
import { SubscriptionLike } from 'rxjs';
import { PersonSearchService } from '../_services/person-search.service';
import { ERROR_MESSAGE_CONSTANTS } from '../constants/error-message-constants';

import moment from 'moment';
import { RecaptchaComponent } from 'ng-recaptcha';
import { SessionStorageService } from '../_services/session-storage.service';
import { NewExperienceModalComponent } from '../hire-person-search/new-experience-modal/new-experience-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare const clevertap;
declare var ga
declare var dataLayer;

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    standalone: false
})
export class SignupComponent implements OnInit, OnDestroy {
  candidate_form: UntypedFormGroup;
  loginform: UntypedFormGroup;
  basicdetails: any;
  signupform: boolean;
  confirmemailform: boolean = false
  login_form: boolean = false;
  termsacceptError: boolean = false;
  loginError: boolean;
  loginErrorMsg: string = null;
  /** True after a privileged login's password was accepted and an emailed code is awaited */
  mfaRequired = false;
  mfaOtp = '';
  mfaToken: string = null;
  /** Seconds until a resend is allowed, for display. Derived from resendAllowedAt. */
  resendWait = 0;
  /** Time (ms) when the backend allows the next code. Set from the backend's retryAfter when it answers. */
  private resendAllowedAt = 0;
  /** Resends left for this sign-in. null until the first code is sent. */
  resendsLeft: number = null;
  /** Set after the 4th wrong code. Verification and resend stop for this sign-in. */
  otpLocked = false;
  /** True while a login request is in flight. Stops a double click or repeated Enter from sending it twice. */
  private loginInProgress = false;
  /** Why Get OTP is disabled on the sign-in form while resendWait counts down: otp_cooldown, otp_resend_limit or otp_locked */
  loginWaitCode: string = null;

  /** Time left in the wait, for the sign-in form message. Minutes for a block, seconds when under a minute. */
  get loginWaitText(): string {
    if (this.resendWait >= 60) {
      const minutes = Math.ceil(this.resendWait / 60);
      return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
    }
    return `${this.resendWait} ${this.resendWait === 1 ? 'second' : 'seconds'}`;
  }
  /** True from Verify until the login that follows it succeeds or fails. Keeps the code screen up meanwhile. */
  verifyingOtp = false;

  /** CS agent ghost login: the page was opened from the admin panel link. Signs in with email and password, no code. */
  get isGhostLogin(): boolean {
    return !!this.sessionStorageService.getItem('gldata');
  }
  private resendTimer: any = null;
  alreadyExist: boolean;
  verifyMessage: string;
  successMessage: any;
  errorMessage: any;
  referredvia: string;
  verifyEmailStatus: number; // 2 : Email not verified , 3 : email Sent but didn't receive
  federatedLoginEmailNotRegistered: boolean = false;
  redirectedFromCompanypages: boolean = false;
  companypagesInfo: any;
  emailFromCompanyPages: any;
  isMobile: boolean = false;
  /**Check for beta user */
  invalid_beta_user_msg = false;

  invalidGLData: boolean = false;

  @ViewChild('googleSignUpButton') googleSignUpButton: ElementRef<HTMLInputElement>;
  @ViewChild('googleLoginButton') googleLoginButton: ElementRef<HTMLInputElement>;

  @ViewChild(RecaptchaComponent) recaptchaComponent: RecaptchaComponent;
  googleUser: any;
  registeredVia: string;
  subscriptiondetails: any = {};
  isteamMember: boolean;
  teamadminemailid: any;
  googlejwttoken:any;
  googleDataCredsSubscription: SubscriptionLike;
  show: any
  geoIpLocationData: { country: string, city: string, region: string, continent: string } = {
    country: 'India',
    city: 'Mumbai',
    region: 'Maharashtra',
    continent: 'Asia'
  }

  /**
   * reCaptcha key from environment file
   */
  recaptchaKey: string = environment.reCaptchaKey;
  /**
   * Used to show/hide reCaptcha
   */
  showCaptcha: boolean = false;

  constructor(public fb: UntypedFormBuilder, private loginservice: LoginService, private router: Router, private route: ActivatedRoute,
    private localstorageservice: LocalStorageService, private sessionStorageService: SessionStorageService,
    private googleLoginService: GoogleLoginService, private transactionservice: TransactionService, private personSearchService: PersonSearchService, private globalService: GlobalService,
  private modalService: NgbModal) {
    }



  ngOnInit() {
    if(window.innerWidth <= 425 ){
      this.isMobile = true;
    } else{
      this.isMobile = false;
    }
    this.companypagesInfo = {
      companyid: this.route.snapshot.queryParamMap.get('companyid'),
      companyname: this.route.snapshot.queryParamMap.get('companyname'),
      industry: this.route.snapshot.queryParamMap.get('industry')
    }

    if(this.companypagesInfo && this.companypagesInfo.companyid ){
      this.redirectedFromCompanypages = true;
    }
    if (this.router.url.includes('gldata')) {
      localStorage.clear();
      sessionStorage.clear();
      this.sessionStorageService.setItem('gldata', this.route.snapshot.queryParams.gldata);
      this.router.navigateByUrl('/login');
    }

    if(this.localstorageservice.getItem('userid')){
      if(!this.redirectedFromCompanypages && this.router.url.includes('teaminvite')){

        // this.route.queryParams.subscribe(params => {
        //   this.teamadminemailid = GlobalService.decryptData(params['tokense']);
        //   if (this.teamadminemailid) {
        //     localStorage.setItem('teaminviteurl', environment.frontendurl + this.router.url)
        //   }
        // });
        // let url = localStorage.getItem('teaminviteurl').split('?redirect=')[1].replace(/%2F/g, "/").replace('teaminvite&','teaminvite?');
        // this.router.navigateByUrl(url);

        const baseUrl = {
          urlArray: [environment.frontendurl + this.router.url],
          openWithLink: true
        }

        localStorage.setItem('teaminviteurl', JSON.stringify(baseUrl));
        this.router.navigateByUrl('/search')

      }else if(!this.redirectedFromCompanypages){
        // handle route redirection
        if(this.router.url.includes('?redirect=')) {
          const urlToRedirectTo = decodeURIComponent(this.router.url.split('?redirect=')[1]);
          urlToRedirectTo && this.router.navigateByUrl(urlToRedirectTo);
        } else this.router.navigateByUrl('/search')
      } else{
        this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
      }
    }else if(this.router.url.includes('teaminvite')){
      this.router.navigateByUrl('/login')
    }

    if (this.router.url.includes('login')) {
      this.openLoginForm()
    } else {
      this.signupform = true
    }

    // this.route.queryParams.subscribe(params => {
    //   this.teamadminemailid = GlobalService.decryptData(params['tokense']);
    //   if (this.teamadminemailid) {
    //     localStorage.setItem('teaminviteurl', environment.frontendurl + this.router.url)
    //   }
    // });

    this.referredvia = this.route.snapshot.queryParamMap.get('ref');
    this.candidate_form = this.fb.group({
      firstName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      lastName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      workid: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$'), Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      mobileno: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern('^[+]?[0-9 ]*$')])],
      designation: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      password: ['', Validators.required],
      companyname: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      termsaccept: [''],
      confirmpwd: ['', Validators.required]
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
    }

    this.loginform = this.fb.group({
      emailid: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')])],
      password: ['', Validators.required],
      captcha_code: [false]
    })


    if (this.router.url.includes('verified')) {
      this.route.queryParamMap.subscribe((res: any) => {
        let activationcode = res.params.verified
        let email = res.params.email;
        if (activationcode && email) {
          if (activationcode === '446080') { // if email verified
            this.toastmessage("Email verified successfully", "success")
            this.loginform.patchValue({ emailid: email });
          } else if (activationcode === '807024') { // if candidate email doesn't exisit
            this.toastmessage("Email doesn't exist", "error")
          } else if (activationcode === '667030') { // verification link expired
            setTimeout(() => {
              this.toastmessage("Verification link expired", "error")
              // const modalRef = this.modalService.open(this.verifyModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false })
            }, 200);
          } else if (activationcode === '307730') { // some other error
            this.verifyMessage = 'Something went wrong. Please try again later';
          }
        }
      })
    }

    if (this.signupform || this.login_form) {
      this.federatedLinkedInLogin();
      setTimeout(() => {
        if (this.signupform) {
          this.googleLoginService.initGoogleSignIn(this.googleSignUpButton?.nativeElement,this.signupform);
        } else {
          this.googleLoginService.initGoogleSignIn(this.googleLoginButton?.nativeElement,this.signupform);
        }
      }, 100);
    }
    this.googleDataCredsSubscription = this.googleLoginService.credentialDataObservable.subscribe((data)=>{
      this.googlejwttoken=data;
      this.logincandidate(true, null, 'google')
    })

    this.emailFromCompanyPages = this.route.snapshot.queryParamMap.get('email')
    if( this.redirectedFromCompanypages && this.emailFromCompanyPages && this.emailFromCompanyPages.length>0 && this.emailFromCompanyPages.toLowerCase() != 'undefined' ){
      this.candidate_form.patchValue({workid: this.emailFromCompanyPages })
    }
  }
  ngOnDestroy(): void {
    this.mfaToken = null;
    this.mfaRequired = false;
    this.verifyingOtp = false;
    this.googleDataCredsSubscription && this.googleDataCredsSubscription.unsubscribe();
    this.stopResendCountdown();
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }


  openLoginForm() {
    this.login_form = true;
    this.confirmemailform = false;
    this.signupform = false
  }

  reconfirmpwd() {
    if (this.candidate_form.value.password == this.candidate_form.value.confirmpwd) {
      return this.candidate_form['controls'].confirmpwd.setErrors(null)
    } else {
      return this.candidate_form['controls'].confirmpwd.setErrors({ 'invalidpwd': true })
    }
  }

  candidatesignup() {
    if (this.candidate_form.valid) {
      var isRedirectExtension = false
      if(this.route.snapshot.queryParamMap.get('source') == 'extension'){
        isRedirectExtension = true
      }
      if (this.candidate_form.value.termsaccept == true) {
        this.termsacceptError = false
        let data = {
          firstname: "'" + this.candidate_form.value.firstName + "'",
          lastname: "'" + this.candidate_form.value.lastName + "'",
          loginemail: "'" + this.candidate_form.value.workid + "'",
          pwd: "'" + this.candidate_form.value.password + "'",
          designation: "'" + this.candidate_form.value.designation + "'",
          extn: "'" + this.candidate_form.value.mobileno + "'",
          company: "'" + this.candidate_form.value.companyname + "'",
          registeredvia: isRedirectExtension ? "'Extension'" : "'registration form'"
        }

        if (this.referredvia) {
          data['referredvia'] = "'" + this.referredvia + "'"
        }

        this.loginform.patchValue({ emailid: data.loginemail.replace(/'/g, "") });

        if (this.teamadminemailid) {
          data['teamadminemailid'] = "'" + this.teamadminemailid + "'"
          data['teaminviteurl'] = "'" + environment.frontendurl + this.router.url + "'"
          data['referredvia'] = "'teaminvite'"
        }

        if(this.redirectedFromCompanypages){
          data['referredvia'] = "'companypages'";
          data['companypageinfo'] = this.companypagesInfo;
        }

        this.loginservice.signup(data).subscribe((res: any) => {
          if (res.status == 'success') {
            // let clevertap_signup = {
            //   "Name": this.candidate_form.value.firstName + " " + this.candidate_form.value.lastName,
            //   "Email": this.candidate_form.value.workid,
            //   "Phone": "+91" + this.candidate_form.value.mobileno,
            //   companyname: this.candidate_form.value.companyname,
            //   designation: this.candidate_form.value.designation,
            //   registeredvia: isRedirectExtension ? "'Extension'" : "'registration form'"
            // }

            // clevertap.onUserLogin.push({ "Site": clevertap_signup })
        //    clevertap.event.push("signup", clevertap_signup);
            this.signupform = false
            this.confirmemailform = true;
            dataLayer.push({'event':'signup','signup': 'true'});
            if(this.redirectedFromCompanypages){
              dataLayer.push({'event':'company_pages_signup','company_pages_signup': 'true'});
            }
            // ga('send', 'event', 'WebbTreeSignup', 'WebbTreeSignup', 'First Signup');
          }
          else if (res.message == 'Duplicate user') {
            this.alreadyExist = true
          } else {
            console.log("errror")
          }
        })
      } else {
        this.termsacceptError = true
      }
    }
    else {
      this.validateAllFormFields(this.candidate_form);
    }
  }

  /**
   * Used to validate re-captcha
   * @param event
   */
  resolvedCaptcha( event: any) {
    if (event && event.length > 0) {
      this.loginform.patchValue({ captcha_code: true });
    } else {
      this.loginform.patchValue({ captcha_code: false });
    }
  }

  /**
   * Used to reset re-captcha
   */
  resetCaptcha(): void {
    this.recaptchaComponent?.reset();
    this.loginform.patchValue({ captcha_code: false });
  }

  /**
   * Verifies the emailed code for a privileged login. On success the login is submitted again with the
   * same credentials, and the backend completes it because the code was verified.
   */
  submitLoginOtp() {
    const otp = (this.mfaOtp || '').trim();
    // A resend still in flight would replace the code being verified
    if (this.otpLocked || this.verifyingOtp || this.loginInProgress) return;
    if (!/^\d{6}$/.test(otp)) {
      this.loginErrorMsg = 'Enter the 6-digit verification code';
      return;
    }
    this.verifyingOtp = true;
    this.loginErrorMsg = null;
    this.loginservice.verifyLoginOtp({ email: this.loginform.value.emailid, otp }).subscribe(
      (res: any) => {
        if (res.status == 'success') {
          // Stay on the code screen. logincandidate() submits the login with mfaToken and navigates on success.
          this.mfaOtp = '';
          this.mfaToken = res.mfaToken;
          this.stopResendCountdown();
          this.logincandidate();
        } else {
          this.verifyingOtp = false;
          this.loginErrorMsg = res.message || 'Invalid or expired verification code';
        }
      },
      (err) => {
        this.verifyingOtp = false;
        const body = err?.error || {};
        if (body.code == 'otp_locked') {
          this.otpLocked = true;
          this.stopResendCountdown();
        }
        this.loginErrorMsg = body.message || 'Invalid or expired verification code';
      }
    );
  }

  /** Sends a new code. The backend replaces the previous code, so the old one stops working. */
  resendLoginOtp() {
    if (this.otpLocked || this.verifyingOtp || this.resendWait > 0 || this.resendsLeft === 0) return;
    this.mfaOtp = '';
    this.logincandidate();
  }

  /** Leaves the code step, so the email or password can be changed */
  cancelLoginOtp() {
    if (this.verifyingOtp) return;
    this.mfaRequired = false;
    this.mfaOtp = '';
    this.loginErrorMsg = null;
    this.otpLocked = false;
    this.stopResendCountdown();
  }

  /**
   * Shows the wait before the next resend. The backend's retryAfter is turned into a deadline, and the
   * seconds shown are recomputed from it, so the countdown stays right when the tab is in the background.
   * The backend enforces the wait. This only decides when the Resend link is shown.
   */
  private startResendCountdown(seconds: number, resendsLeft: number) {
    this.stopResendCountdown();
    this.resendsLeft = resendsLeft ?? this.resendsLeft;
    this.resendAllowedAt = Date.now() + Math.max(0, Number(seconds) || 0) * 1000;
    this.updateResendWait();
    if (this.resendWait > 0) {
      this.resendTimer = setInterval(() => this.updateResendWait(), 1000);
    }
  }

  private updateResendWait() {
    this.resendWait = Math.max(0, Math.ceil((this.resendAllowedAt - Date.now()) / 1000));
    if (this.resendWait === 0) this.stopResendCountdown();
  }

  private stopResendCountdown() {
    clearInterval(this.resendTimer);
    this.resendTimer = null;
    this.resendWait = 0;
  }

  /**
   * Opens the code step for a sign-in whose code was already sent (cooldown, resend limit, or lock).
   * This is also what happens after Back or a page refresh: the backend still has the flow, so the
   * wait shown is what is left of it, not a new one.
   */
  private showOtpStepFromError(err) {
    this.loginError = false;
    this.invalid_beta_user_msg = false;
    this.mfaRequired = true;
    this.otpLocked = err.error?.code == 'otp_locked';
    // For a cooldown the countdown already shows the live wait, and the code that was sent still works
    this.loginErrorMsg = err.error?.code == 'otp_cooldown' ? null : err.error?.message;
    this.startResendCountdown(err.error?.retryAfter, err.error?.resendsLeft);
  }

  async logincandidate(federatedLogin?: boolean, emailID?: string, loginwith?: string) {
    if (this.loginform.valid || (federatedLogin && emailID && loginwith !='google') || (federatedLogin && loginwith =='google')) {
      // The backend also allows only one code per wait, this just avoids the extra request
      if (this.loginInProgress || (!federatedLogin && !this.mfaRequired && this.resendWait > 0)) return;
      this.loginInProgress = true;
      let data = {
        email: (federatedLogin) ? emailID : this.loginform.value.emailid
      }
      if (federatedLogin) {
        data['loginwith'] = loginwith
        if(loginwith =='google'){
          data['email']=null
          data['googlecredentialjwttoken']=this.googlejwttoken;
        }
      } else {
        data['password'] = this.loginform.value.password
        // Set after a privileged login's emailed code was verified (see submitLoginOtp)
        if (this.mfaToken) {
          data['mfaToken'] = this.mfaToken;
        }
      }

      this.loginErrorMsg = null;
      this.invalid_beta_user_msg = false;
      let userdata: any = {};
      if(this.showCaptcha == true && this.loginform.getRawValue().captcha_code == true){
        data['captcha_code'] = true;
      }

      let ontheflyResp;
      try {
        ontheflyResp = await this.loginservice.ontheflytoken({ agent: window.navigator.userAgent }).toPromise();
      } catch (err) {
        this.loginInProgress = false;
        throw err;
      }
      // save token in local storage
      sessionStorage.setItem('token', ontheflyResp['message']['token']);

      // save current time in local storage
      sessionStorage.setItem('emit', `${+new Date()}`);

      this.loginservice.login(data).subscribe((res: any) => {
        this.loginInProgress = false;
        if (res.status == 'mfa_required') {
          this.mfaRequired = true;
          this.verifyingOtp = false;
          this.otpLocked = false;
          this.loginErrorMsg = null;
          this.loginError = false;
          this.startResendCountdown(res.retryAfter, res.resendsLeft);
          return;
        }
        if (res.status == 'success') {
          res.data = JSON.parse(GlobalService.decryptData(res.data))
          userdata = res.data;
          console.log(userdata, 'userdata after login');
          const updateLocation = userdata.updateLocation;
          let usernumber = res.data.usernumber
          let userid = res.data.userid
          let ufname = res.data.firstname
          let ulname = res.data.lastname
          let token = res.data.token
          let firstlogin = res.data.firstlogin
          let emailId=res.data.loginemail;

          // Default page preference
          userdata.preferenceData = GlobalService.PREFERENCE_DATA_DEFAULT;

          this.localstorageservice.setItem('tabName', 'quicksearch');
          this.localstorageservice.setItem('userdata', userdata)
          this.localstorageservice.setItem('stripesubscriptionid',userdata.stripesubscriptionid)
          this.localstorageservice.setItem('stripecustomerid',userdata.stripecustomerid)
          this.localstorageservice.setItem('stripebillingcountry',userdata.stripebillingcountry)
          this.localstorageservice.setItem('usernumber', usernumber)
          this.localstorageservice.setItem('userid', userid)
          this.localstorageservice.setItem('usermailid', (federatedLogin ? emailId : this.loginform.value.emailid))
          this.localstorageservice.setItem('ufname', ufname)
          this.localstorageservice.setItem('ulname', ulname)
          this.localstorageservice.setItem('token', token)
          this.localstorageservice.setItem('role', res.data.role);
          this.localstorageservice.setItem('hasEUPersonSearchAccess', res.data.hasEUPersonSearchAccess);
          this.localstorageservice.setItem('hasEUTalentInsightsAccess', res.data.haseutalentinsightsaccess)
          this.localstorageservice.setItem('hasaisourcingaccess', userdata?.hasaisourcingaccess);
          this.localstorageservice.setItem('hasjoblistingaccess', userdata?.hasjoblistingaccess);
          this.localstorageservice.setItem('hasjoinedaisourcingwaitlist', userdata?.hasjoinedaisourcingwaitlist)
          this.localstorageservice.setItem('isglsession', userdata?.isglsession);
          this.localstorageservice.setItem('autopilotslotaccess', userdata?.autopilotslotsaccess);
          this.localstorageservice.setItem('autopilotprojectslots', userdata?.autopilotprojectslots);
          this.localstorageservice.setItem('defaultContinent', userdata?.preferredsearchcontinent)

          if (res.data.teaminviteurl) {
            // localStorage.setItem('teaminviteurl', res.data.teaminviteurl)
            localStorage.setItem('teaminviteurl', JSON.stringify(res.data.teaminviteurl));
          }

          this.loginservice.getGeoIpLocationOfUser(updateLocation).subscribe((res: any) => {

            if (res.status == 'success' && res.data && !res.data.isEU && !['europe', 'antarctica'].includes(res.data.continent) && res.data.continentCode != 'EU') {
              this.geoIpLocationData.country = res.data.country;
              this.geoIpLocationData.city = res.data.city;
              this.geoIpLocationData.region = res.data.region;
              this.geoIpLocationData.continent = res.data.continent;
            }
            this.personSearchService.setGeoIpLocationOfUser(this.geoIpLocationData);
            this.localstorageservice.setItem('region', this.geoIpLocationData.continent ? this.geoIpLocationData.continent.toLowerCase() : 'asia')
            this.localstorageservice.setItem('userGeoIpLocation', JSON.stringify(this.geoIpLocationData));
            this.localstorageservice.setItem('talentRegion', this.geoIpLocationData.continent ? this.geoIpLocationData.continent.toLowerCase() : 'asia');
          });

          //to send usernumber to chrome extension
          let chromeid = localStorage.getItem('extensionID');
          let isChromeInstalled;
          if (chromeid) {
            try {
              window['chrome'].runtime.sendMessage(chromeid, { action: 'login', usernumber: usernumber, userid: userid, firstname: ufname, lastname: ulname, token: token, userdata: userdata });
              window['chrome'].runtime.sendMessage(chromeid, { action: 'getSimilarCandidateResult' }, function (res) {
                if (res.similarCandidateData) {
                  isChromeInstalled = true
                  const chromeExtensionData = {
                    "User ID": userdata.userid,
                    "Extension Status": "Installed"
                  }
                  clevertap.event.push("Chrome Extension Check", chromeExtensionData);
                  console.log("Chrome Extension Install CT Event ");
                }
              });
            } catch (error) {
              isChromeInstalled = false
              const chromeExtensionData = {
                "User ID": userdata.userid,
                "Extension Status": "Not Installed"
              }
              clevertap.event.push("Chrome Extension Check", chromeExtensionData);
              console.log("Chrome Extension Not Install CT Event ");

              console.error('Here is the error message', error);
            }
          }
          this.fetchcredits();
          this.fetchAccessDetails();
          this.loginservice.isloggedin(usernumber).subscribe((res: any) => {
            if (res.status == 'success') {
              this.verifyEmailStatus = undefined;
              if (this.router.url.includes('?redirect=') && !this.router.url.includes('teaminvite&')) {
                let url = decodeURIComponent(this.router.url.split('?redirect=')[1]);
                if(this.redirectedFromCompanypages){
                  this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
                } else {
                  this.router.navigateByUrl(url);
                }
              }
              // else if (localStorage.getItem('teaminviteurl') && localStorage.getItem('teaminviteurl').includes('teaminvite&')) {
              //   // let url = localStorage.getItem('teaminviteurl').replace('teaminvite&','teaminvite?')
              //   let url = localStorage.getItem('teaminviteurl').split('?redirect=')[1].replace(/%2F/g, "/").replace('teaminvite&', 'teaminvite?');
              //   if(this.redirectedFromCompanypages){
              //     this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
              //   } else {
              //     this.router.navigateByUrl(url);
              //   }
              //   localStorage.removeItem('teaminviteurl')
              // }
              else {
                setTimeout(() => {
                  if (firstlogin == 0 && isChromeInstalled != true) {
                    if(this.redirectedFromCompanypages){
                      this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
                    } else {
                      this.router.navigateByUrl('/firstlogin');
                       if(userdata.hasseenhiringprojectmodal  == 0)
                      this.modalService.open(NewExperienceModalComponent, { windowClass: 'new-exp-modal', centered: true, backdrop: 'static', keyboard: false });
                    }
                  } else {
                    if(this.redirectedFromCompanypages){
                      this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
                    } else {
                      this.router.navigateByUrl('/search');
                      if(userdata.hasseenhiringprojectmodal  == 0)
                      this.modalService.open(NewExperienceModalComponent, { windowClass: 'new-exp-modal', centered: true, backdrop: 'static', keyboard: false });
                    }
                  }
                }, 500)
              }

            }
            else {
              this.toastmessage('Something went Wrong', 'error')
            }
          })

          //-Clevertap Register profile


          const userPlanData = this.localstorageservice.getItem('userPlanData');
          if(userdata){
            let phone = userdata.extn ? "+91"+userdata.extn : "";
            let userprofile = {
              "Identity": userdata.userid,
              "First Name": userdata.firstname,
              "Last Name": userdata.lastname,
              "Email": userdata.loginemail,
              "Company": userdata.company,
              "Team Member": userPlanData?.isteammember ? "Yes": "No",
              "Role Type": userdata.role,
              "Plan Type": userPlanData?.plantype,
              "Plan Name": userPlanData?.paymentplanname,
              "Last Login": userdata.lastlogintime,
              "Contact credits balaance": userdata.balancebasiccontactenrichmentcredits,
              "User Type": userdata.usertypename
            }
                    clevertap.enableLocalStorageEncryption(true);

          clevertap.onUserLogin.push({ "Site": userprofile });
          }
          //-Clevertap Login event
          const loginData = {
            "User ID": userdata.userid,
            "Login Time": moment().format()
          }
          clevertap.event.push("Login", loginData);
          console.log("Login CT Event");
          if(userdata.isfirstlogin == true) {
            /**
             * when user login first time
             */
            const firstLoginParams = {
              "User ID": userid,
              "Login Time": moment().format(),
            }
            clevertap.event.push("First Login", firstLoginParams);
          }
          if(this.route.snapshot.queryParamMap.get('source') == 'extension'){
          //  clevertap.event.push("Login_Extension");
          }

          console.log("Login CT event");
        } else if(res.status == 'failure' && res.message == 'Rate limit exceeded'){
          this.showCaptcha = true;
        } else if (federatedLogin) {
          this.federatedLoginEmailNotRegistered = true;
        }else {
          this.loginError = true
          this.verifyEmailStatus = undefined
          this.invalid_beta_user_msg = false;
        }
      }, (err)=>{
        this.loginInProgress = false;
        if (this.verifyingOtp) {
          // The login that completes the code step failed. Return to the sign-in form so the error is visible.
          this.verifyingOtp = false;
          this.mfaToken = null;
          this.mfaRequired = false;
          this.mfaOtp = '';
          this.stopResendCountdown();
        }
        if (err.status == 400 && err.error.message == 'Invalid gldata') {
          this.invalidGLData = true;
        } else if (err.status == 400 && err.error.message == 'Expired gldata') {
          this.invalidGLData = true;
        } else if(err.status == 400 && err.error.message == 'Email or password is invalid'){
          this.loginError = true;
          this.invalid_beta_user_msg = false
        } else if(err.status == 400 && err.error.message == 'Email is not verified'){
          this.verifyEmailStatus = 2;
          this.loginError = false;
          this.invalid_beta_user_msg = false
        } else if(err.status == 403){
          this.verifyEmailStatus = undefined;
          this.loginError = false;
          this.invalid_beta_user_msg = true
        } else if (err.status == 429 && ['otp_cooldown', 'otp_resend_limit', 'otp_locked'].includes(err.error?.code) && !this.mfaRequired) {
          // Sign-in again during a wait or block (e.g. after Back): stay on this form, Get OTP is enabled when it ends
          this.loginError = false;
          this.invalid_beta_user_msg = false;
          this.loginWaitCode = err.error.code;
          this.startResendCountdown(err.error.retryAfter, err.error.resendsLeft);
        } else if (err.status == 429 && ['otp_locked', 'otp_cooldown', 'otp_resend_limit'].includes(err.error?.code)) {
          // Must come before the generic 429 (captcha) branch below
          this.showOtpStepFromError(err);
        } else if (err.status == 503 && err.error?.message == 'Unable to send verification code. Please try again.') {
          this.loginError = false;
          this.loginErrorMsg = err.error.message;
        } else if(err.status == 429){
          this.invalid_beta_user_msg = false;
          this.showCaptcha = true;
        } else{
          this.loginError = true;
          this.verifyEmailStatus = undefined;
          this.invalid_beta_user_msg = false;
        }
      })
    }
    else {
      this.validateAllFormFields(this.loginform)
    }
    this.resetCaptcha();
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  resendVerficationLink() {


    if (this.loginform.controls.emailid.valid) {
      let data = {
        loginemail: this.loginform.value.emailid,
      }
      this.loginservice.resendVerificationEmail(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.toastmessage('Email link sent', 'success')
          this.verifyEmailStatus = 3
        } else {
          if (res.message == 'Email already verified') {
            this.toastmessage('Email already verified', 'error')
          } else {
            this.toastmessage('Something went Wrong', 'error')
          }
        }
      })
    } else {
      this.validateAllFormFields(this.loginform)
    }
  }

  registerUserViaFederatedLogin(userDetails: any, type: string) {
    let data = {
      registeredvia: "'" + type + "'"
    }
    if(type!='google'){
      data['firstname']= "'" + userDetails.firstName + "'"
      data['lastname']="'" + userDetails.lastName + "'"
      data['loginemail']="'" + userDetails.email + "'"
    }
    else{
      //add jwt token from google authentication
      data['googlecredentialjwttoken']=userDetails.googlejwttoken;
    }

    if (this.referredvia) {
      data['referredvia'] = "'" + this.referredvia + "'"
    }

    if (this.teamadminemailid) {
      data['teamadminemailid'] = "'" + this.teamadminemailid + "'"
      data['teaminviteurl'] = "'" + environment.frontendurl + this.router.url + "'"
      data['referredvia'] = "'teaminvite'"
    }

    if(this.redirectedFromCompanypages){
      data['referredvia'] = "'companypages'";
    }

    this.loginservice.signup(data).subscribe((res: any) => {
      if (res.status == 'success') {
        dataLayer.push({'event':'signup','signup': 'true'});
        if(this.redirectedFromCompanypages){
          dataLayer.push({'event':'company_pages_signup','company_pages_signup': 'true'});
        }
        //ga('send', 'event', 'WebbTreeSignup', 'WebbTreeSignup', 'First Signup');
        if(type=='google'){
          this.logincandidate(true, null, type);
        }
        else{
          this.logincandidate(true, userDetails.email, type);
        }
      } else if (res.message == 'Duplicate user') {
        this.alreadyExist = true;
      }
      else {
        console.log("error");
        this.toastmessage('Something went Wrong', 'error');
      }
    })
  }

  signUpWithLinkedIn() {
    window.location.href = environment.linkedinurlredirect + window.location.origin + '/signup&state=' + window.location.origin + '/signup&scope=r_liteprofile%20r_emailaddress';
  }

  loginWithLinkedIn() {
    window.location.href = environment.linkedinurlredirect + window.location.origin + '/login&state=' + window.location.origin + '/login&scope=r_liteprofile%20r_emailaddress';
  }

  federatedLinkedInLogin() {
    this.route.queryParamMap.subscribe((param: any) => {
      let data = {
        code: param.params.code,
        state: window.location.origin + (this.signupform ? '/signup' : '/login')
      }

      if (data.code) {
        this.loginservice.federatedLinkedInLogin(data)
          .subscribe((res: any) => {
            if (res.status === 'success' && res.message) {
              let userDetails = {
                firstName: res.message.firstname,
                lastName: res.message.lastname,
                email: res.message.personalemail
              };
              if (data.state.includes('/signup')) {
                this.registerUserViaFederatedLogin(userDetails, 'linkedin');
              } else {
                this.loginform.patchValue({ emailid: userDetails.email })
                this.logincandidate(true, userDetails.email, 'linkedin');
              }
              if(this.redirectedFromCompanypages){
                this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
              }
            } else {
              this.toastmessage('Something went Wrong', 'error')
            }
          });
      }
    });
  }

  fetchcredits() {
    this.transactionservice.updateAllCreditsForCurrentUser().subscribe((userData: any) => {
      this.subscriptiondetails = { ...this.subscriptiondetails, ...userData };
    });
  }

  /**
   * Fetch access details for the current user
   */
  fetchAccessDetails() {
    this.transactionservice.updateAccessDetailsForCurrentUser().subscribe();
  }

  /**
   * Check if the sign-in button should be enabled based on the captcha status
   */
  enabledSignIn() {
    // Waiting before another code can be requested
    if (!this.mfaRequired && this.resendWait > 0) {
      return false;
    }
    if(this.showCaptcha){
      if (this.loginform.getRawValue().captcha_code == true) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  redirect() {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", 'https://webbtree.freshdesk.com/support/tickets/new');
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
  }
}

